const namedHtmlEntities: Record<string, string> = {
  amp: "&",
  apos: "'",
  gt: ">",
  lt: "<",
  nbsp: "\u00A0",
  quot: '"',
};

const decodeCodePoint = (value: number, fallback: string): string => {
  if (!Number.isFinite(value) || value < 0) return fallback;

  try {
    return String.fromCodePoint(value);
  } catch {
    return fallback;
  }
};

export const decodeHtmlEntities = (
  value?: null | string,
): string | undefined => {
  if (typeof value !== "string") return undefined;

  return value
    .replace(/&#x([0-9a-f]+);/gi, (match, hex: string) => {
      return decodeCodePoint(Number.parseInt(hex, 16), match);
    })
    .replace(/&#(\d+);/g, (match, decimal: string) => {
      return decodeCodePoint(Number.parseInt(decimal, 10), match);
    })
    .replace(/&([a-z]+);/gi, (match, name: string) => {
      return namedHtmlEntities[name.toLowerCase()] ?? match;
    });
};
